import React from "react"

export default function ({
  message,
  dataCy,
}: {
  message: string
  dataCy: string
}) {
  return (
    <div data-cy="dashboard-error" className="flex flex-col min-h-[80vh] px-10">
      <div className="m-auto w-4/5 sm:w-2/5">
        <div className="flex flex-col min-h-[80vh] w-70vw justify-center">
          <h1 className="mb-8">Something went wrong...</h1>
          <p className="text-lg" data-cy={dataCy}>
            {message}{" "}
            <a
              className="underline text-brick"
              href="https://api.whatsapp.com/send/?phone=447723477585&text&type=phone_number&app_absent=0"
            >
              get in touch
            </a>
            <br />
          </p>
        </div>
      </div>
    </div>
  )
}
